import { Check } from "lucide-react";
import { Button } from "./ui/button";

export const PricingCard = ({ 
  title, 
  price, 
  features, 
  packageId, 
  description,
  priceSubtext,
  isPopular = false,
  onSelect 
}) => {
  return (
    <div 
      data-testid={`pricing-card-${packageId}`}
      className={`
        relative rounded-2xl p-8 md:p-10 transition-all duration-300 hover:shadow-[0_12px_24px_rgba(0,0,0,0.06)]
        ${isPopular 
          ? 'bg-slate-50/50 border border-primary/20 ring-1 ring-primary/5 shadow-[0_2px_8px_rgba(0,0,0,0.04)]' 
          : 'bg-white border border-slate-200 shadow-[0_2px_8px_rgba(0,0,0,0.04)]'
        }
      `}
    >
      {isPopular && (
        <div 
          data-testid="recommended-badge"
          className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-amber-600 text-white px-4 py-1 rounded-full text-sm font-medium"
        >
          おすすめ
        </div>
      )}
      
      <div className="space-y-6">
        <div>
          <h3 
            data-testid={`plan-title-${packageId}`}
            className="text-2xl font-semibold text-primary mb-3"
          >
            {title}
          </h3>
          {description && (
            <p 
              data-testid={`plan-description-${packageId}`}
              className="text-sm leading-relaxed text-slate-600 mb-4"
            >
              {description}
            </p>
          )}
          <div className="flex items-baseline gap-2 mb-3">
            <span 
              data-testid={`plan-price-${packageId}`}
              className="text-5xl md:text-6xl font-bold font-numbers tracking-tight text-primary"
            >
              {price.toLocaleString()}
            </span>
            <span className="text-lg text-slate-600">円</span>
          </div>
          {priceSubtext && (
            <p 
              data-testid={`price-subtext-${packageId}`}
              className="text-sm leading-relaxed text-slate-600"
            >
              {priceSubtext}
            </p>
          )}
        </div>

        <div className="space-y-4 py-6 border-t border-slate-200">
          {features.map((feature, index) => (
            <div 
              key={index}
              data-testid={`feature-${packageId}-${index}`}
              className="flex items-start gap-3"
            >
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-primary flex items-center justify-center mt-0.5">
                <Check className="w-3 h-3 text-white" />
              </div>
              <span className="text-base leading-relaxed text-slate-600">
                {feature}
              </span>
            </div>
          ))}
        </div>

        <Button
          data-testid={`cta-button-${packageId}`}
          onClick={() => onSelect(packageId)}
          className="w-full rounded-full bg-primary hover:bg-primary/90 text-primary-foreground py-6 text-base font-medium transition-all duration-200 hover:scale-[1.02]"
        >
          このプランで申し込む
        </Button>
      </div>
    </div>
  );
};
